import React, { useEffect, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';

const SandboxCreative = props => {
  const clientjsScriptContainer = useRef(null);

  useEffect(() => {
    // clear out existing ad and mark ad slot as not-visited
    const strDiv = document.querySelector('[data-str-native-key]');
    if (strDiv) {
      strDiv.innerHTML = '';
      strDiv.removeAttribute('data-str-visited-flag');
      strDiv.setAttribute('data-stx-response-name', 'sandbox');
    }

    window.sandbox = props.butlerResponse;
    if (window.STR) {
      window.STR.Tag.boot();
    } else {
      clientjsScriptContainer.current.appendChild(clientjsScript());
    }
  }, [props.butlerResponse]);

  // scripts do not execute unless manually injected like this
  const clientjsScript = () => {
    const newScript = document.createElement('script');
    newScript.id = 'clientjs-script';
    newScript.src = '//sdk.sharethrough.com/gc.js';
    return newScript;
  };

  return (
    <Fragment>
      <div ref={clientjsScriptContainer} />
      <div className="fake-image" />
      <div className="fake-content" />
      <div className="fake-content" />
      <div
        data-cache="false"
        data-count="false"
        data-stx-response-name="sandbox"
        data-str-native-key="9e987ada"
        id="sharethrough-div"
      >
        Sharethrough tag still loading.
      </div>
      <div className="fake-image" />
      <div className="fake-content" />
      <div className="fake-content" />
    </Fragment>
  );
};

SandboxCreative.propTypes = {
  butlerResponse: PropTypes.object.isRequired
};

window.SandboxCreative = SandboxCreative;

export default SandboxCreative;
